<template>
  <div id="contact-page">
    <div v-if="content" v-editable="content">
      <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      content: null
    };
  },
  methods: {
    async fetchData() {
      this.id = this.$route.params.id;
      const { data } = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/contact/${this.id}`
      );
      this.content = data.story.content;
    }
  },
  created() {
    this.fetchData();
    if (this.$storyblok) {
      this.$storyblok.init();
      this.$storyblok.on(["change", "published"], () =>
        window.location.reload()
      );
      this.$storyblok.on("input", ({ story }) => {
        this.content = story.content;
      });
    }
  }
};
</script>

<style lang="scss">
</style>
